import React, { useMemo } from "react";
import CustomDropdown from "../atoms/CustomDropdown";

/**
 * Kullanıcı rolü (firma rol şablonu) seçici — panelin genel `CustomDropdown`
 * tasarımı. Kullanıcı detayındaki Rol kartı ve firma Kullanıcılar sekmesi
 * aynı bileşeni kullanır (#168).
 *
 * Şablon listesi henüz gelmediyse ya da kullanıcının şablonu listede yoksa
 * (silinmiş/başka firmanın şablonu) mevcut rol adı `displayValue` ile gösterilir.
 *
 * @param {Array}    templates     firma rol şablonları ({ _id, name })
 * @param {string}   value         seçili şablon id'si
 * @param {string}   displayValue  şablon bulunamazsa gösterilecek rol adı
 * @param {Function} onChange      (templateId, template) => void — aynı şablon seçilirse çağrılmaz
 */
export default function RoleTemplateDropdown({
  templates = [],
  value,
  displayValue,
  onChange,
  disabled = false,
  loading = false,
  className = "w-44 sm:w-52",
}) {
  const options = useMemo(
    () => templates.map((t) => ({ id: String(t._id), label: t.name })),
    [templates]
  );
  const selected =
    options.find((o) => o.id === String(value || "")) ||
    (displayValue ? { id: value || "__current__", label: displayValue } : null);

  return (
    <CustomDropdown
      compact
      className={className}
      value={selected}
      options={options}
      placeholder="Rol seçin"
      showSearch={options.length > 6}
      searchPlaceholder="Rol ara..."
      emptyMessage="Bu firmada rol şablonu yok"
      disabled={disabled}
      loading={loading}
      onChange={(opt) => {
        if (!opt?.id || opt.id === String(value || "")) return;
        onChange(opt.id, templates.find((t) => String(t._id) === opt.id));
      }}
    />
  );
}
